<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <box-form v-if="box"
          @submit="submit"
          :init-box="box"
          :val-errors="valErrors"
          submit-text="Speichern"
        />
      </card>
    </div>
  </div>
</template>

<script>
import BoxForm from './box-form'

export default {
  components: { BoxForm },
  data () {
    return {
      valErrors: [],
      box: null
    }
  },
  methods: {
    async submit (box) {
      await this.initCsrf()

      this.valErrors = []

      const reqData = {
        name: box.name,
        barcode: box.barcode
      }

      reqData.products = box.products.map(product => {
        return {
          product_id: product.product.id,
          quantity: product.quantity
        }
      })
      this.$http.put(`/boxes/${box.id}`, reqData).then(({ data }) => {
        this.$notify({
          message: 'Box erfolgreich bearbeitet.',
          type: 'success'
        })
        this.redirectBack('/boxes')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  },
  created () {
    this.$http.get(`/boxes/${this.$route.params.id}`).then(({ data }) => {
      data.products = data.products.map(product => {
        return {
          product,
          quantity: product.pivot.quantity
        }
      })
      this.box = data
    })
  }
}
</script>

<style>
</style>
